import script from "./contactInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./contactInfo.vue?vue&type=script&setup=true&lang=js"

import "./contactInfo.vue?vue&type=style&index=0&id=0423c154&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0423c154"]])

export default __exports__